import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/okta-redirect')({
  staticData: { team: 'users-infra' },
});
